import { type IGridStrategy } from './abstract.strategy';
import { EventEmitter } from '../../../system/classes/event-emitter';
import { AngularInjector } from '../../../system/angular/AngularInjector';

export class HeaderGridStrategy extends EventEmitter implements IGridStrategy {
    private a9GridConstants;

    constructor(
        private strategy: IGridStrategy,
        header = 0
    ) {
        super();
        this.a9GridConstants = <any>AngularInjector.get('a9GridConstants');
        header = header || this.a9GridConstants.headerRowHeight;
        this.addHeader(header);
    }

    public getGridHeight(): number {
        return this.strategy.getGridHeight();
    }

    public getInnerGridHeight(): number {
        return this.strategy.getInnerGridHeight();
    }

    public getGridPageAmount(): number {
        return this.strategy.getGridPageAmount();
    }

    public addHeader(headerHeight = 0): void {
        this.strategy.addHeader(headerHeight);
    }

    public on(event, listener, options = null) {
        return this.strategy.on(event, listener, options);
    }

    public showPagination() {
        return this.strategy.showPagination();
    }

    getCssClasses() {
        return this.strategy.getCssClasses();
    }

    isStretchable() {
        return this.strategy.isStretchable();
    }

    public usesAllItems(): boolean {
        return this.strategy.usesAllItems();
    }

    public detach() {
        this.strategy.detach();
    }
    public setGridElement(gridElement: HTMLElement): void {
        this.strategy.setGridElement(gridElement);
    }
}
